import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

export default class DropDownMaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      staggeredQuickSearch: false
    };
  }

  handleSeasonCheck = (seasonType) => {
    this.setState(prevState => ({
      [seasonType]: !prevState[seasonType]
    }), () => {
      // Create array of selected seasons
      const selectedSeasons = [];
      if (this.state.allSeason) selectedSeasons.push('All Season');
      if (this.state.allWeather) selectedSeasons.push('All Weather');
      if (this.state.winter) selectedSeasons.push('Winter');
      if (this.state.summer) selectedSeasons.push('Summer');
      
      // Store in localStorage (replace old winter only logic)
      if (selectedSeasons.length > 0) {
        localStorage.setItem('selected_tire_seasons', JSON.stringify(selectedSeasons));
        localStorage.removeItem('performance tire'); // Remove old key
      } else {
        localStorage.removeItem('selected_tire_seasons');
      }
    });
  };

  makeSubmitButton(button) {
    const wtselected = localStorage.getItem('category');
    return (
      <div style={{ width: '100%' }}>
        {wtselected === 'Tires' &&
          <div style={{ 
            width: '100%', 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center',
            marginBottom: '15px'
          }}>

            
            <div style={{ 
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1px 15px',
              justifyContent: 'center',
              maxWidth: window.innerWidth <= 768 ? '320px' : '100%',
              margin: '0 auto'
            }}>
              {[
                { key: 'allSeason', label: 'All Season', icon: 'https://www.soratwheels.ca/media/allseason.png' },
                { key: 'allWeather', label: 'All Weather', icon: 'https://www.soratwheels.ca/media/allweather.png' },
                { key: 'winter', label: 'Winter', icon: 'https://www.soratwheels.ca/media/snowtag.png' },
                { key: 'summer', label: 'Summer', icon: 'https://www.soratwheels.ca/media/summer.png' }
              ].map(season => (
                <label key={season.key} style={{ 
                  color: 'white', 
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  gap: '8px',
                  width: window.innerWidth <= 768 ? 'calc(50% - 7.5px)' : 'auto',
                  justifyContent: 'flex-start'
                }}>
                  <input 
                    style={{ 
                      width: '18px', 
                      height: '18px'
                    }} 
                    type="checkbox" 
                    checked={this.state[season.key]}
                    onChange={() => this.handleSeasonCheck(season.key)}
                  />
                  <img 
                    src={season.icon} 
                    alt={season.label}
                    style={{ 
                      width: '20px', 
                      height: '20px',
                      objectFit: 'contain'
                    }} 
                  />
                  {season.label}
                </label>
              ))}
            </div>
          </div>
        }
        <br/>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <button 
            className="sizeSelection-staggeredBtnGo" 
            style={{ 
              marginTop: '0px', 
              marginBottom: '30px',
              background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '3px',
              fontSize: '16px',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(197, 0, 0, 0.3)',
              transition: 'all 0.3s ease',
              minWidth: '120px',
              minHeight: '50px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(197, 0, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(197, 0, 0, 0.3)';
            }}
            onClick={event => {
              localStorage.removeItem('performance tire');
              this.props.whenClicked(this.state);
            }}>
            {button.name}
          </button>
        </div>
      </div>
    );
  }

  componentDidMount() {
    // Clear previous season selections when component mounts
    localStorage.removeItem('selected_tire_seasons');
    localStorage.removeItem('performance tire');
    
    this.props.buttonlist.forEach(btn => {
      const st = {};
      st[btn.id] = '';
      this.setState(st);
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { whenClicked } = this.props;
    if (whenClicked) {
      const options = Object.assign({}, this.state, { staggeredQuickSearch: this.state.staggeredQuickSearch });
      whenClicked(options);
    }
  }

  render() {
    const { onChange } = this.props;
    const tireInfoArray = [window.sessionStorage.getItem('treadWidth'), window.sessionStorage.getItem('tireProfile'), window.sessionStorage.getItem('wheelSizes')];
    const items = this.props.buttonlist.map((button, i) => {

      if (button.type == 'separator') {
        return <hr key={i} style={{ 
          width: '100%', 
          border: 'none',
          borderTop: '2px dashed #e0e0e0', 
          margin: '1px 0' 
        }}/>;
      }
      if (button.type == 'separator2') {
        return <hr key={i} style={{ 
          width: '100%', 
          border: 'none', 
          margin: '1px 0' 
        }}/>;
      }

      const options = [];
      const renderInput = !button.options;
      if (button.options) {
        for (let j = 0; j < button.options.length; j++) {
          options.push(
            <option key={i * 1000 + j} value={button.options[j].id}>
              {button.options[j].name}
            </option>
          );
        }
      }

      // Quick Search with toggle for staggered
      if (button.id === 'all_params') {
        const modernFieldStyle = {
          width: '100%',
          padding: '12px 16px',
          fontSize: '15px',
          fontWeight: '500',
          border: '2px solid #e0e0e0',
          borderRadius: '8px',
          color: '#333',
          transition: 'all 0.3s ease',
          outline: 'none',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
        };

        return (
          <div key={i} style={{ 
            flex: '0 1 100%',
            display: 'flex',
            alignItems: 'center',
            gap: '1px 15px',
            justifyContent: 'center'
          }}>
            {/* Toggle Switch */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
              <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>Staggered:</span>
              <label style={{ 
                position: 'relative', 
                display: 'inline-block', 
                width: '50px', 
                height: '24px',
                cursor: 'pointer',
                margin: 0
              }}>
                <input 
                  type="checkbox" 
                  checked={this.state.staggeredQuickSearch}
                  onChange={(e) => this.setState({ staggeredQuickSearch: e.target.checked })}
                  style={{ opacity: 0, width: 0, height: 0 }}
                />
                <span style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: this.state.staggeredQuickSearch ? '#C50000' : '#ccc',
                  borderRadius: '24px',
                  transition: '0.3s'
                }}>
                  <span style={{
                    position: 'absolute',
                    content: '',
                    height: '18px',
                    width: '18px',
                    left: this.state.staggeredQuickSearch ? '28px' : '3px',
                    bottom: '3px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    transition: '0.3s'
                  }}></span>
                </span>
              </label>
              <span style={{ fontSize: '14px', fontWeight: '500', color: this.state.staggeredQuickSearch ? '#C50000' : '#999' }}>
                {this.state.staggeredQuickSearch ? 'ON' : 'OFF'}
              </span>
            </div>

            {/* Input Fields */}
            <FormGroup controlId="formControlsSelect" style={{ 
              marginBottom: '0',
              flex: '0 1 300px',
              minWidth: '250px'
            }}>
              <FormControl 
                style={modernFieldStyle}
                placeholder={this.state.staggeredQuickSearch ? "Front (e.g. 2056016)" : button.name}
                onFocus={(e) => {
                  e.target.style.borderColor = '#C50000';
                  e.target.style.boxShadow = '0 0 0 3px rgba(197, 0, 0, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e0e0e0';
                  e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                }}
                onChange={event => {
                  const st = {};
                  const val = event.target.value;
                  if (val.length === 7) {
                    st.tread_width = val.substring(0, 3);
                    st.wheel_profile = val.substring(3, 5);
                    st.wheel_size = val.substring(5, 7);
                  }
                  if (val.length === 8) {
                    st.tread_width = val.substring(0, 2);
                    st.wheel_profile = parseInt(val.substring(2, 6)) / 100;
                    st.wheel_size = val.substring(6, 8);
                  }
                  this.setState(st);
                  if (onChange) {
                    onChange(button.id, event.target.value, this.state);
                  }
                }} 
              />
            </FormGroup>

            {this.state.staggeredQuickSearch && (
              <FormGroup controlId="formControlsSelect" style={{ 
                marginBottom: '0',
                flex: '0 1 300px',
                minWidth: '250px'
              }}>
                <FormControl 
                  style={modernFieldStyle}
                  placeholder="Rear (e.g. 2256018)"
                  onFocus={(e) => {
                    e.target.style.borderColor = '#C50000';
                    e.target.style.boxShadow = '0 0 0 3px rgba(197, 0, 0, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e0e0e0';
                    e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                  }}
                  onChange={event => {
                    const st = {};
                    const val = event.target.value;
                    if (val.length === 7) {
                      st.tread_width_rear = val.substring(0, 3);
                      st.wheel_profile_rear = val.substring(3, 5);
                      st.wheel_size_rear = val.substring(5, 7);
                    }
                    if (val.length === 8) {
                      st.tread_width_rear = val.substring(0, 2);
                      st.wheel_profile_rear = parseInt(val.substring(2, 6)) / 100;
                      st.wheel_size_rear = val.substring(6, 8);
                    }
                    this.setState(st);
                    if (onChange) {
                      onChange('all_params_rear', event.target.value, this.state);
                    }
                  }} 
                />
              </FormGroup>
            )}
          </div>
        );
      }

      const modernFieldStyle = {
        width: '100%',
        padding: '12px 16px',
        fontSize: '15px',
        fontWeight: '500',
        border: '2px solid #e0e0e0',
        borderRadius: '8px',
        color: '#333',
        transition: 'all 0.3s ease',
        outline: 'none',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
      };

      const modernSelectStyle = {
        width: '100%',
        padding: '12px 16px',
        fontSize: '15px',
        fontWeight: '500',
        border: '2px solid #e0e0e0',
        borderRadius: '8px',
        color: '#333',
        transition: 'all 0.3s ease',
        outline: 'none',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        cursor: 'pointer',
        appearance: 'none',
        backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23C50000\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 14px center',
        backgroundSize: '16px',
        paddingRight: '40px'
      };

      return (
        <FormGroup key={i} controlId="formControlsSelect" style={{ 
          marginBottom: '0',
          flex: button.id === 'all_params' ? '0 1 300px' : '1 1 calc(33.333% - 10px)',
          minWidth: button.id === 'all_params' ? '250px' : '200px'
        }}>
          {renderInput &&
            <FormControl 
              style={modernFieldStyle}
              placeholder={button.name} 
              onFocus={(e) => {
                e.target.style.borderColor = '#C50000';
                e.target.style.boxShadow = '0 0 0 3px rgba(197, 0, 0, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e0e0e0';
                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
              }}
              onChange={event => {
                const st = {};
                if (button.id === 'all_params') {
                  const val = event.target.value;
                  if (val.length === 7) {
                    st.tread_width = val.substring(0, 3);
                    st.wheel_profile = val.substring(3, 5);
                    st.wheel_size = val.substring(5, 7);
                  }
                  if (val.length === 8) {
                    st.tread_width = val.substring(0, 2);
                    st.wheel_profile = parseInt(val.substring(2, 6)) / 100;
                    st.wheel_size = val.substring(6, 8);
                  }
                  this.setState(st);
                  if (onChange) {
                    onChange(button.id, event.target.value, this.state);
                  }
                }
                if (button.id === 'wheel_centerbore') {
                  const val = event.target.value;
                  st.wheel_centerbore = val;
                  this.setState(st);
                  if (onChange) {
                    onChange(button.id, event.target.value, this.state);
                  }
                }
                if (button.id === 'wheels_offset_min' ) {
                  const valmin = event.target.value;
                  st.wheel_offset_min = valmin;
                  window.sessionStorage.setItem('wheel_offset_min_front', st.wheel_offset_min );
                  this.setState(st);
                  if (onChange) {
                    onChange(button.id, event.target.value, this.state);
                  }
                }
                if (button.id === 'wheels_offset_max') {
                  const valmaxx = event.target.value;
                  st.wheel_offset_max = valmaxx;
                  window.sessionStorage.setItem('wheel_offset_max_front', st.wheel_offset_max );
                  this.setState(st);
                  if (onChange) {
                    onChange(button.id, event.target.value, this.state);
                  }
                }
              }} 
            />
          }
          {!renderInput && 
            <FormControl 
              componentClass="select"
              style={modernSelectStyle}
              onFocus={(e) => {
                e.target.style.borderColor = '#C50000';
                e.target.style.boxShadow = '0 0 0 3px rgba(197, 0, 0, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e0e0e0';
                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
              }}
              onChange={event => {
                const st = {};
                st[button.id] = event.target.value;
                this.setState(st);
                if (onChange) {
                  onChange(button.id, event.target.value, this.state);
                }
              }}
            >
              <option style={{ color: '#999' }}>{button.name}</option>
              {options}
            </FormControl>
          }
        </FormGroup>
      );
    });

    const submitButton = this.makeSubmitButton(this.props.submitButton);

    return (
      <div>
        <div style={{ padding: '20px' }}>
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: '1px 15px',
            maxWidth: '800px', 
            margin: '0 auto',
            justifyContent: 'center'
          }}>
            {items}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          {submitButton}
        </div>
      </div>
    );
  }
}

DropDownMaker.propTypes = {
  btnStyle: React.PropTypes.object.isRequired,
  buttonlist: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func,
  submitButton: React.PropTypes.object.isRequired,
  whenClicked: React.PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./src/components/subcomponents/DropDownMaker.jsx